import InvoiceImportable, {InvoiceImportableDto} from "./InvoiceImportable"
import {ExternalLinkDto} from "./ExternalLink"
import HttpClient from "../helpers/HttpClient"
import {HttpError, isError} from "../helpers/Error"
import {INTEGRATION_KEY} from "./Constants"

const IntegrationToBeValidated = [INTEGRATION_KEY.LIGHTSPEED_RETAIL]

class InvoiceImportableService {
    private static httpClient:HttpClient<InvoiceImportable, InvoiceImportableDto> =
        new HttpClient<InvoiceImportable, InvoiceImportableDto>(InvoiceImportable)

    static async getUnVoidedExternalInvoices(externalLinksDto: ExternalLinkDto[]): Promise<InvoiceImportableDto[] | HttpError > {
        const requests: object[] = [] //todo define object type
        for (let i = 0; i < externalLinksDto.length; i++){
            if (!IntegrationToBeValidated.includes(externalLinksDto[i].attributes.integrationKey)) continue

            const integrationKey = externalLinksDto[i].attributes.integrationKey
            const externalId = externalLinksDto[i].attributes.externalId
            requests.push(InvoiceImportableService.httpClient.get(`/exported-invoice/${integrationKey}/${externalId}`))
        }

        let toVoid: InvoiceImportableDto[] = []
        const responses = await Promise.all(requests)
        for  (const res of responses) {
            if (!isError(res)) {
                const importable = res as InvoiceImportable
                if (!importable.getDto().isVoided) toVoid = [...toVoid, importable.getDto()]
            } else {
                return res as HttpError
            }
        }
        return toVoid
    }
}

export default InvoiceImportableService


// WEBPACK FOOTER //
// ./src/state/integration/InvoiceImportableService.ts